const STRINGS = {
  allRightsReserved: "Wells Fargo. All rights reserved.",
  navAriaLabel: "Legal information",
  privacyLabel: "Privacy, Cookies, Security, and Legal"
};
export default STRINGS;